import { ErrorCode } from '@qaytim/shared';

import { AdminApiError } from './admin-api';
import { strings } from '../i18n/strings';

/**
 * Kod → o'zbekcha jumla.
 *
 * API hech qachon foydalanuvchi ko'radigan gapni yubormaydi (§0.4), shuning uchun tarjima
 * BITTA joyda turadi. Har bir ekran o'zi `switch` yozsa, bir xil kod ikki joyda ikki xil
 * jumlaga aylanardi.
 */
export function describeError(error: unknown): string {
  if (!(error instanceof AdminApiError)) return strings.drawErrors.unknown;

  switch (error.code) {
    case 'NETWORK_ERROR':
      return strings.drawErrors.network;
    case 'UPLOAD_FAILED':
      return strings.uploads.failed;
    case ErrorCode.DRAW_ALREADY_COMPLETED:
      return strings.drawErrors.alreadyCompleted;
    case ErrorCode.DRAW_NOT_COMPLETED:
      return strings.drawErrors.notCompleted;
    case ErrorCode.DRAW_STEP_ALREADY_REVEALED:
      return strings.drawErrors.stepAlreadyRevealed;
    case ErrorCode.DRAW_REVEAL_OUT_OF_ORDER:
      return strings.drawErrors.revealOutOfOrder;
    case ErrorCode.DRAW_SHORTLIST_COMPLETE:
      return strings.drawErrors.shortlistComplete;
    case ErrorCode.DRAW_REVEAL_STATE_STALE:
      return strings.drawErrors.revealStateStale;
    case ErrorCode.DRAW_NO_ELIGIBLE_TICKETS:
      return strings.drawErrors.noEligibleTickets;
    case ErrorCode.DRAW_NOT_FOUND:
    case ErrorCode.NOT_FOUND:
      return strings.drawErrors.notFound;
    case ErrorCode.VALIDATION_FAILED:
      return strings.drawErrors.validation;
    case ErrorCode.DRAW_PRIZE_LABEL_REQUIRED:
      return strings.drawErrors.prizeLabelRequired;
    case ErrorCode.RATE_LIMITED:
      return strings.drawErrors.rateLimited;
    default:
      return strings.drawErrors.unknown;
  }
}
